import z from 'zod';

export const TEAM_ACTIVITY_DIGEST_PERIODS = ['week', 'previous', '2-weeks', 'month', '3-months', 'all'] as const;

export type TeamActivityDigestPeriod = (typeof TEAM_ACTIVITY_DIGEST_PERIODS)[number];

export const TeamActivityDigestQuery = z.object({
    team: z.string(),
    period: z.enum(TEAM_ACTIVITY_DIGEST_PERIODS).default('week'),
    date: z.string().date().optional(),
});

export type TeamActivityDigestQuery = z.infer<typeof TeamActivityDigestQuery>;

export const DEFAULT_QUESTION_MESSAGES = 10;
export const MAX_QUESTION_MESSAGES = 100;

export const TeamCreditDigestQuery = TeamActivityDigestQuery.extend({
    questionMessages: z.number().int().min(1).max(MAX_QUESTION_MESSAGES).default(DEFAULT_QUESTION_MESSAGES),
});

export type TeamCreditDigestQuery = z.infer<typeof TeamCreditDigestQuery>;
